import type { Release } from '../releases';

export default {
  id: '2026-11-02-psd-revision-impact',
  at: '2026-11-02T09:09:00Z',
  title: 'Новая ревизия ПСД показывает, что она затрагивает, и сама ставит поручения',
  modules: ['psd', 'estimates', 'schedule'],
  items: [
    'В карточке альбома — блок «Что затрагивает ревизия»: изменённые листы и связанные с ними позиции сметы, работы графика, заявки на материалы и акты скрытых работ. Каждый блок виден только тем, у кого есть доступ к разделу; суммы не показываются.',
    'Когда ГИП ставит штамп «В производство работ» на ревизию взамен действующей, составитель затронутой сметы и составитель графика получают поручение проверить свои позиции и работы — оно появляется у них в «Ждёт меня». В журнал ревизии пишется итог: сколько листов, позиций, работ и актов затронуто.',
    'Первый выпуск альбома отмечает его полученным: ограничение пакета работ «комплект не получен» снимается само.',
  ],
  why: 'После выхода новой ревизии сметчик и планировщик узнавали об изменениях случайно, а пакет работ ждал отметки о получении комплекта вручную.',
  link: '/psd',
} satisfies Release;
